module.exports = __webpack_public_path__ + "static/shape3-d2d69b0268bb9d27a211b2e1247d7f37.png";